document.addEventListener('DOMContentLoaded', () => {
    const navigationBlocks = document.querySelectorAll('.navigation-block');

    navigationBlocks.forEach((block) => {
        const title = block.querySelector('.navigation-block-title');
        const container = block.querySelector('.navigation-block-container');

        title.addEventListener('click', () => {
            const isOpen = container.style.maxHeight;

            // Växla mellan öppet och stängt
            if (isOpen) {
                container.style.maxHeight = null;
            } else {
                container.style.maxHeight = container.scrollHeight + 'px';
            }
        });
    });
});